import { makeStyles } from '@material-ui/core';

const adDetailsFormTextInputStyles = makeStyles({
  root: {
    width: '100%',
    '& .MuiOutlinedInput-input': {
      padding: '12.5px 14px',
    },
    '& .MuiFormLabel-root': {
      fontSize: '1rem',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(10px, 15px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(16px, -6px) scale(0.75)',
      },
    },
  },
});

const adDetailsFormSelectStyles = makeStyles({
  root: {
    width: '100%',
    '&.MuiOutlinedInput-input': {
      padding: '12.5px 14px',
    },
  },
});

const adDetailsFormDatePickerStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-input': {
      padding: '12.5px 14px',
    },
  },
});

const adDetailsFormDatePickerLabelStyles = makeStyles({
  root: {
    fontSize: '1rem',
    '&.MuiInputLabel-outlined': {
      transform: 'translate(14px, 15px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
    },
  },
});

const useRadioButtonStyles = makeStyles({
  root: {
    '&.MuiIconButton-root': {
      padding: '5px',
      paddingLeft: '10px',
    },
  },
});

export {
  adDetailsFormDatePickerLabelStyles,
  adDetailsFormDatePickerStyles,
  adDetailsFormSelectStyles,
  adDetailsFormTextInputStyles,
  useRadioButtonStyles,
};
